import { render, staticRenderFns } from "./TutorDashboardAvailabilitiesFooter.vue?vue&type=template&id=4edecca5&scoped=true&"
import script from "./TutorDashboardAvailabilitiesFooter.vue?vue&type=script&lang=js&"
export * from "./TutorDashboardAvailabilitiesFooter.vue?vue&type=script&lang=js&"
import style0 from "./TutorDashboardAvailabilitiesFooter.vue?vue&type=style&index=0&id=4edecca5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edecca5",
  null
  
)

export default component.exports